export function hasOwn(obj: Record<string, unknown>, key: string) {
  return Object.prototype.hasOwnProperty.call(obj, key)
}

// @ts-expect-error not yet officially supported
if (!Object.hasOwn) {
  // @ts-expect-error not yet officially supported
  Object.hasOwn = hasOwn
}
